<mat-accordion style="clear: both; display: block;">
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        Aide spots MIC/MIG
      </mat-panel-title>
      <mat-panel-description>
        Informations supplémentaires programmation spots
      </mat-panel-description>
    </mat-expansion-panel-header>
    <p>
      -> Le code de modification doit être renseigné pour utiliser l'outil<br>
      -> Le spot audio doit être stocké dans Winmedia dans "Publicité" => "MIC/MIG"<br>
      -> La virgule d'intro sera ajoutée automatiquement<br>
      Si besoin d'une virgule d'outro, elle doit être dans le spot audio directement<br>
      (les virgules utilisées sont "PUB DECRO" et "PUB RACCRO" dans Winmedia "Virgules SAT")<br>
      -> Création de la campagne en renseignant les différents champs<br>
      (le Créneau indique quelles balises vont être utilisées dans le conducteur, généralement "SUN AUTOPROMO 1")<br>
      -> Une fois la campagne enregistrée, l'outil "diff-spot-auto-winmedia" s'occupe de programmer les spots au fur et à mesure<br><br><br>
    </p>
  </mat-expansion-panel>
</mat-accordion>

<h2>Code edition campagnes</h2>

<div style="margin: 24px;">
  <mat-form-field appearance="fill">
    <mat-label>Code edition</mat-label>
    <input [formControl]="modificationCode" matInput placeholder="Code edition" value="">
  </mat-form-field>
</div>

<h2>Nouvelle campagne</h2>

<div class="formNewContainer">
  <mat-form-field appearance="fill">
    <mat-label>Date Campagne MIC/MIG</mat-label>
    <mat-date-range-input [formGroup]="range" [rangePicker]="picker">
      <input matStartDate formControlName="start" placeholder="Date début">
      <input matEndDate formControlName="end" placeholder="Date fin">
    </mat-date-range-input>
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-date-range-picker #picker></mat-date-range-picker>
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>Nom Campagne</mat-label>
    <input [formControl]="campagneName" matInput placeholder="Nom campagne" value="">
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>Stations</mat-label>
    <mat-select [formControl]="stations" multiple>
      <mat-option *ngFor="let station of dataList.stations" [value]="station.IStation">{{station.Name}}</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>Spots</mat-label>
    <mat-select [formControl]="spots" multiple>
      <mat-option *ngFor="let spot of dataList.spots" [value]="{imedia: spot.IMedia, name: returnSpotName(spot)}">{{returnSpotName(spot)}}</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>Créneau</mat-label>
    <mat-select [formControl]="slots">
      <mat-option *ngFor="let slot of dataList.slots" [value]="slot.Performer">{{slot.Performer}}</mat-option>
    </mat-select>
  </mat-form-field>

  <button (click)="nextPage()" color="primary" mat-flat-button>Suivant</button>
</div>


<h2>Campagnes enregistrées</h2>

<table style="width: 100%" mat-table [dataSource]="mediasMatTable">
  <ng-container matColumnDef="id">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> ID </th>
    <td mat-cell style="padding-right: 40px" *matCellDef="let element"> {{ element.id }} </td>
  </ng-container>

  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> Nom </th>
    <td mat-cell *matCellDef="let element"> {{ element.name }} </td>
  </ng-container>

  <ng-container matColumnDef="periode">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> Periode </th>
    <td mat-cell *matCellDef="let element"> {{ element.periode }} </td>
  </ng-container>

  <ng-container matColumnDef="stations">
    <th mat-header-cell *matHeaderCellDef> Stations </th>
    <td mat-cell *matCellDef="let element"> {{ element.stations }} </td>
  </ng-container>

  <ng-container matColumnDef="slot">
    <th mat-header-cell *matHeaderCellDef> Slot </th>
    <td mat-cell *matCellDef="let element"> {{ element.slot }} </td>
  </ng-container>

  <ng-container matColumnDef="spots_awaiting_scheduling">
    <th mat-header-cell *matHeaderCellDef> Spots en attente de programmation </th>
    <td mat-cell *matCellDef="let element"> {{ element.spots_awaiting_scheduling }} </td>
  </ng-container>

  <ng-container matColumnDef="spots_scheduled">
    <th mat-header-cell *matHeaderCellDef> Spots programmés </th>
    <td mat-cell *matCellDef="let element"> {{ element.spots_scheduled }} </td>
  </ng-container>

  <ng-container matColumnDef="delete_remaining_spots">
    <th mat-header-cell *matHeaderCellDef> Supprimer spots en attente </th>
    <td mat-cell *matCellDef="let element">
      <button *ngIf="element.spots_awaiting_scheduling != 0" style="background-color: #f44336; min-width: 48px; padding: 0 8px; margin-right: 8px;" (click)="deleteRemainingSpots(element)" mat-flat-button>
        <mat-icon style="color: white; vertical-align: top; height: 35px; margin: 0;" svgIcon="delete"></mat-icon>
      </button>
      <button *ngIf="element.spots_awaiting_scheduling == 0" disabled style="background-color: #8d8d8d; min-width: 48px; padding: 0 8px; margin-right: 8px;" (click)="deleteRemainingSpots(element)" mat-flat-button>
        <mat-icon style="color: white; vertical-align: top; height: 35px; margin: 0;" svgIcon="delete"></mat-icon>
      </button>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
